<template>
  <div v-if="body_show" class="page flex-col">
    <div class="section_1 flex-col">
      <div class="text-wrapper_60 flex-row">
        <span class="text_3">{{ data.extra['姓名'] }}</span>
      </div>
      <div class="group_66 flex-row">
        <img
          class="thumbnail_126"
          referrerpolicy="no-referrer"
          src="@/assets/ceping113/thumbnail_126.png"
        />
        <span class="text_4">{{ data.extra['性别'] }}</span>
        <em class="thumbnail_5"></em>
        <img
          class="thumbnail_127"
          referrerpolicy="no-referrer"
          src="@/assets/ceping113/thumbnail_127.png"
        />
        <span class="text_5">{{ data.extra['身份2'] }}{{ data.extra['身份3'] }}</span>
      </div>
      <div class="group_67 flex-row">
        <img
          class="thumbnail_128"
          referrerpolicy="no-referrer"
          src="@/assets/ceping113/thumbnail_128.png"
        />
        <span class="text-group_1">{{ data.extra['所在省市'] }}</span>
      </div>
      <div class="group_68 flex-row">
        <img
          class="thumbnail_129"
          referrerpolicy="no-referrer"
          src="@/assets/ceping113/thumbnail_129.png"
        />
        <span class="text-group_2">测评日期：{{ data.ctime }}</span>
      </div>
      <img src="@/assets/ceping113/section_1_stamp.png" class="stamp" />
      <div v-if="data.assessment_code" class="assessment-code">已使用测评码：{{ data.assessment_code }}</div>
    </div>

    <div class="group_18 flex-col">
      <div class="box_42 flex-row">
        <div class="box_15 flex-col"></div>
        <span class="text_49">测评介绍</span>
      </div>
      <span class="text_50"
        >本报告基于多元智能理论，为您提供对学生学习特质的全面分析。通过对学生智能类型的评估，报告旨在帮助家长和学生了解学生的学习优势与需要提升的领域。报告还提供了个性化的学习建议，帮助学生充分发挥智能优势，提升整体学习表现。</span
      >
    </div>

    <div class="section_2 flex-col">
      <span class="text_6">注意事项</span>
      <span class="paragraph_1"
        >为了有效地运用本次测评报告结果，请注意以下事项：</span
      >
      <span class="text_53"><strong>1. 优势因人而异：</strong>学习优势的表现因人而异，无需与他人比较。每个人的学习风格和优势领域都具有独特性，应以自我成长为目标。</span>
      <span class="text_53"><strong>2. 发展是动态的：</strong>报告反映的是你在当前学习阶段的表现，这并不决定未来。随着你的努力、环境的变化和兴趣的拓展，你的学习优势和能力可能会发生积极转变。</span>
      <span class="text_53"><strong>3. 关注优势，激发潜力：</strong>本报告旨在帮助你更加了解自己的学习优势，并以此为基础，探索新的学习方法或活动，从而激发更多的潜力。</span>
      <span class="text_53"><strong>4. 优势不等于局限：</strong>某些领域的优势并不意味着你仅能在这一方向取得进步。请勇于探索其他领域，尝试突破可能的边界。</span>
      <span class="text_53"><strong>5. 报告仅为参考：</strong>测评结果是一种工具，帮助你了解自己，但不能完全定义你的能力和发展潜力。建议结合实际学习体验和个人兴趣，综合运用建议。</span>
      <span class="text_53"><strong>6. 学习路径因人而异：</strong>适合他人的策略未必完全适合你。本报告提供的是通用性建议，你需要根据自己的实际情况和学习目标，灵活调整和应用。</span>
      <span class="text_53"><strong>7. 从优势中学习：</strong>报告不仅仅为你指出了擅长的领域，也为你提供了进一步提升这些领域的方法。通过深入发挥优势，你可以在学习和生活中获得更多信心与成就感。</span>
      <span class="text_53"><strong>8. 探索多元发展：</strong>虽然报告强调你的优势领域，但也要关注综合能力的提升。多元化发展能为你带来更广阔的学习机会和未来可能性。</span>
      <div class="box_6 flex-col"></div>
    </div>
    <div class="section_3 flex-col">
      <div class="section_19 flex-row justify-between">
        <img
          class="thumbnail_9"
          referrerpolicy="no-referrer"
          src="@/assets/ceping113/thumbnail_9_10_19_20_34_35_46_47.png"
        />
        <div class="image-text_165 flex-row justify-between">
          <span class="text-group_3">测评结果解读</span>
          <img
            class="thumbnail_10"
            referrerpolicy="no-referrer"
            src="@/assets/ceping113/thumbnail_9_10_19_20_34_35_46_47.png"
          />
        </div>
      </div>
      <span class="text_7">以下是你在以下八个优势智能维度上的得分</span>
      <div class="section_20">
        <template v-for="(value, key) in data.result">
          <ProgressIndicator :label="key" :value="value" />
        </template>
      </div>
      <div class="box_10 flex-col">
        <span class="text_16">学习优势智能解释：</span>
        <template v-for="(value, key) in data.result">
          <div class="group_70 flex-row justify-between" v-if="key == '语言智能'">
            <img
              class="thumbnail_130"
              referrerpolicy="no-referrer"
              src="@/assets/ceping113/thumbnail_130.png"
            />
            <span class="text_17">语言智能</span>
          </div>
          <span class="text_18" v-if="key == '语言智能'"
            >语言智能是指运用语言进行交流的能力，包括口头和书面表达的流畅度、清晰度和理解力。这种智能在语文、英语等语言类学科的学习中尤为重要。</span
          >
          <div class="group_71 flex-row justify-between" v-if="key == '人际智能'">
            <img
              class="thumbnail_131"
              referrerpolicy="no-referrer"
              src="@/assets/ceping113/thumbnail_131.png"
            />
            <span class="text_19">人际智能</span>
          </div>
          <span class="text_20" v-if="key == '人际智能'"
            >人际智能是指理解、协调和处理人际关系的能力，包括理解他人情感、有效沟通和社交技巧。这种智能在合作学习、团队任务和与老师同学的沟通中非常重要。</span
          >
          <div class="group_72 flex-row justify-between" v-if="key == '数学逻辑智能'">
            <img
              class="thumbnail_132"
              referrerpolicy="no-referrer"
              src="@/assets/ceping113/thumbnail_132.png"
            />
            <span class="text_21">数学逻辑智能</span>
          </div>
          <span class="text_22" v-if="key == '数学逻辑智能'"
            >数学逻辑智能是指分析问题、解决问题、归纳总结以及逻辑推理的能力。这种能力对数学、物理、化学等需要严密逻辑的学科尤为关键。</span
          >
          <div class="group_73 flex-row justify-between" v-if="key == '空间智能'">
            <img
              class="thumbnail_133"
              referrerpolicy="no-referrer"
              src="@/assets/ceping113/thumbnail_133.png"
            />
            <span class="text_23">空间智能</span>
          </div>
          <span class="text_24" v-if="key == '空间智能'"
            >空间智能是指理解和处理三维空间信息的能力，如观察、构图、设计等。这种能力在数学中的几何、物理中的力学等学科的学习中尤为重要。</span
          >
          <div class="group_74 flex-row justify-between" v-if="key == '身体-运动智能'">
            <img
              class="thumbnail_134"
              referrerpolicy="no-referrer"
              src="@/assets/ceping113/thumbnail_134.png"
            />
            <span class="text_25">身体-运动智能</span>
          </div>
          <span class="text_26" v-if="key == '身体-运动智能'"
            >身体-运动智能是指通过身体协调性和肢体动作来表达情感、完成任务的能力，涵盖运动、手工、实验等实践能力。这种智能对学习中的动手操作、参与实验以及体育表现等有显著影响。</span
          >
          <div class="group_75 flex-row justify-between" v-if="key == '音乐智能'">
            <img
              class="thumbnail_135"
              referrerpolicy="no-referrer"
              src="@/assets/ceping113/thumbnail_135.png"
            />
            <span class="text_27">音乐智能</span>
          </div>
          <span class="text_28" v-if="key == '音乐智能'"
            >音乐智能是指对音乐的理解、表达和创造能力，涵盖旋律、节奏和音调的感知。这种智能对语言学习、情绪调节和创造力的培养具有广泛的应用。</span
          >
          <div class="group_76 flex-row justify-between" v-if="key == '自然观察智能'">
            <img
              class="thumbnail_136"
              referrerpolicy="no-referrer"
              src="@/assets/ceping113/thumbnail_136.png"
            />
            <span class="text_29">自然观察智能</span>
          </div>
          <span class="text_30" v-if="key == '自然观察智能'"
            >自然观察智能是指对自然界的敏锐观察力和归纳能力，特别是在动植物和环境现象中的应用。这种智能在生物、地理等科目学习中非常重要。</span
          >
          <div class="group_77 flex-row justify-between" v-if="key == '内省智能'">
            <img
              class="thumbnail_137"
              referrerpolicy="no-referrer"
              src="@/assets/ceping113/thumbnail_137.png"
            />
            <span class="text_31">内省智能</span>
          </div>
          <span class="text_32" v-if="key == '内省智能'"
            >内省智能是指对自我情感、动机和目标的清晰认识，能够深入反思自身，并调节情绪以应对各种学习和生活挑战的能力。这种能力在管理学习进度、自我激励以及应对学业压力中起着关键作用。</span
          >
        </template>
      </div>
    </div>
    <div class="section_4 flex-col">
      <div class="group_78 flex-row justify-between">
        <img
          class="thumbnail_19"
          referrerpolicy="no-referrer"
          src="@/assets/ceping113/thumbnail_9_10_19_20_34_35_46_47.png"
        />
        <div class="image-text_166 flex-row justify-between">
          <span class="text-group_4">学习优势特征表现</span>
          <img
            class="thumbnail_20"
            referrerpolicy="no-referrer"
            src="@/assets/ceping113/thumbnail_9_10_19_20_34_35_46_47.png"
          />
        </div>
      </div>
      <div class="group_12 flex-col">
        <TitleBubble text="你的学习优势特征" />
        <template v-for="(text) in data.results['高分学习特征']">
          <BulletPoint :content="text" />
        </template>
      </div>
      <div class="group_13 flex-col">
        <TitleBubble text="有待提升的潜能表现" />
        <div class="group_14 flex-row">
          <span class="text_37"
            >提示：以下智能的表现是和自己的其他能力相比，相对还有进一步提升空间。不是和其它同学的比较。</span
          >
          <img
            class="thumbnail_29"
            referrerpolicy="no-referrer"
            src="@/assets/ceping113/thumbnail_29_43.png"
          />
        </div>
        <template v-for="(text) in data.results['低分学习特征']">
          <BulletPoint :content="text" />
        </template>
      </div>
    </div>
    <div class="section_5 flex-col">
      <div class="group_79 flex-row justify-between">
        <img
          class="thumbnail_34"
          referrerpolicy="no-referrer"
          src="@/assets/ceping113/thumbnail_9_10_19_20_34_35_46_47.png"
        />
        <span class="text_40">个性化辅导建议</span>
        <img
          class="thumbnail_35"
          referrerpolicy="no-referrer"
          src="@/assets/ceping113/thumbnail_9_10_19_20_34_35_46_47.png"
        />
      </div>
      <span class="text_41"
        >以下个性化辅导建议帮助学生扬长避短，有效利用其优势，针对性地提升学习中的薄弱领域。</span
      >
      <div class="box_12 flex-col">
        <TitleBubble text="更有效地应用优势智能" />
        <template v-for="(text) in data.results['扬长策略']">
          <BulletPoint :content="text" />
        </template>
      </div>
      <div class="box_13 flex-col">
        <TitleBubble text="针对性地提升学习潜能" />
        <template v-for="(text) in data.results['避短策略']">
          <BulletPoint :content="text" />
        </template>
        <div class="group_15 flex-row">
          <div class="image-text_186 flex-row justify-between">
            <img
              class="thumbnail_43"
              referrerpolicy="no-referrer"
              src="@/assets/ceping113/thumbnail_29_43.png"
            />
            <span class="text-group_24"
              >更多改进建议可联系你的学习力指导师获取。</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="section_6 flex-col">
      <div class="group_80 flex-row justify-between">
        <img
          class="thumbnail_46"
          referrerpolicy="no-referrer"
          src="@/assets/ceping113/thumbnail_9_10_19_20_34_35_46_47.png"
        />
        <div class="image-text_189 flex-row justify-between">
          <span class="text-group_27">结语</span>
          <img
            class="thumbnail_47"
            referrerpolicy="no-referrer"
            src="@/assets/ceping113/thumbnail_9_10_19_20_34_35_46_47.png"
          />
        </div>
      </div>
      <span class="text_47"
        >本报告揭示了你在学习中的独特优势领域，并提供了激发潜力的方向和策略。通过深入了解这些优势，你能够更加高效地规划学习路径，并找到适合自己的成长方式。<br /><br />
请记住，优势是你前进的动力，但成长不仅仅依赖天赋，更需要努力、实践和不断的尝试。不要害怕失败，失败本身就是学习的一部分。无论目前的表现如何，你都可以通过持续努力，进一步拓展自己的能力边界。<br /><br />
学习是一段充满可能性的旅程，你的每一次尝试都在为未来积蓄力量。希望你能以乐观和坚韧的态度面对每一个挑战，以你的学习优势为基础，创造更多精彩的学习体验。<br /><br />
相信你自己！无论现在的起点在哪里，你都有能力通过努力实现更大的目标。愿你在学习的旅程中发现更多的可能性，不断突破自我，书写属于你的精彩篇章！</span
      >
    </div>
    <span class="text_48"
      >本测评由新精英生涯（北京）教育科技有限公司版权所有，违者必究。</span
    >
  </div>
</template>
<script>
import { ceping114_report } from "@/api/measurement";
import ProgressIndicator from "./progress-indicator.vue";
import TitleBubble from "./title-bubble.vue";
import BulletPoint from "./bullet-point.vue";

export default {
  data() {
    return {
      data:{},
      body_show: false,
      title: "",
    }
  },
  methods: {
    pullData() {
      ceping114_report({
        uid: this.$route.query.uid,
        evaluation_id: this.$route.query.evaluation_id
      }).then(data => {
        if (data.code == 10002) {
          this.$router.push({
            path:'/ceping114',
            query:this.$route.query
          });
        }else if (typeof data !== "string") {
          this.body_show = true;
          this.data = data;
          document.title = data.headtitle;
          this.title = data.headtitle;
        } else {
          location.href = data;
        }
      });
    }
  },
  created() {
    this.pullData();
  },
  components: {
    ProgressIndicator,
    TitleBubble,
    BulletPoint,
  }
};
</script>
<style lang="scss" scoped>
@import "@s/common.scss";
.assessment-code {
  margin: 0.4rem 0.6rem 0.5rem;
  color: #333;
  font-size: 0.32rem;
  line-height: 1.5;
  overflow-wrap: anywhere;
}


.page {
  background-color: rgba(245, 245, 245, 1);
  position: relative;
  overflow: hidden;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0.774rem;
  .section_1 {
    position: relative;
    overflow: visible;
    background: url('../../../assets/ceping113/section_1_bg_v2.png')
      100% no-repeat;
    background-size: 100%;
    background-position: 0 -2.34rem;
    padding-left: 0.187rem;
    .stamp {
      position: absolute;
      z-index: 1;
      width: 2.13rem;
      height: 2.13rem;
      right: 0.32rem;
      bottom: -1.31rem;
    }
    .group_64 {
      width: 9.067rem;
      align-self: center;
      .text_105 {
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 0.4rem;
        letter-spacing: -0.30000001192092896px;
        font-weight: normal;
        text-align: right;
        white-space: nowrap;
        line-height: 0.56rem;
      }
      .thumbnail_123 {
        width: 0.454rem;
        height: 0.294rem;
        margin: 0.16rem 0 0.107rem 5.84rem;
      }
      .thumbnail_124 {
        width: 0.4rem;
        height: 0.294rem;
        margin: 0.134rem 0 0.134rem 0.134rem;
      }
      .image_15 {
        width: 0.667rem;
        height: 0.32rem;
        margin: 0.134rem 0 0.107rem 0.134rem;
      }
    }
    .group_65 {
      margin: 0.294rem 0 0 0.24rem;
      .label_7 {
        width: 0.8rem;
        height: 0.64rem;
        margin: 0.267rem 0 0.267rem 0;
      }
      .text_106 {
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 0.453rem;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: right;
        white-space: nowrap;
        line-height: 0.64rem;
        margin: 0.267rem 0 0 1.44rem;
      }
      .box_41 {
        background-color: rgba(216, 216, 216, 0);
        width: 0.107rem;
        height: 0.16rem;
        margin: 0.427rem 0 0.587rem 0.027rem;
      }
      .image-wrapper_1 {
        background-size: 100% 100%;
        margin-left: 0.934rem;
        padding: 0.534rem 0.507rem 0.534rem 0.294rem;
        .thumbnail_125 {
          width: 0.48rem;
          height: 0.107rem;
        }
      }
    }
    .text-wrapper_60 {
      margin: 1.04rem 0.64rem 0 0.64rem;
      .text_3 {
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.746rem;
        font-weight: bolder;
        text-align: left;
        white-space: nowrap;
        line-height: 1.067rem;
      }
    }
    .group_66 {
      margin: 0.107rem 0.667rem 0 0.667rem;
      align-items: center;
      .thumbnail_126 {
        width: 0.32rem;
        height: 0.32rem;
      }
      .text_4 {
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.454rem;
        margin-left: 0.134rem;
      }
      .thumbnail_5 {
        display: inline-block;
        width: 0.027rem;
        height: 0.214rem;
        background-color: rgba(6, 16, 41, 0.1);
        margin: 0.134rem 0 0.107rem 0.187rem;
      }
      .thumbnail_127 {
        width: 0.32rem;
        height: 0.32rem;
        margin-left: 0.214rem;
      }
      .text_5 {
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.454rem;
        margin-left: 0.107rem;
      }
    }
    .group_67 {
      margin: 0.187rem 0.667rem 0 0.667rem;
      align-items: center;
      
      .thumbnail_128 {
        width: 0.32rem;
        height: 0.32rem;
      }
      .text-group_1 {
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.454rem;
        margin-left: 0.134rem;
      }
    }
    .group_68 {
      margin: 0.267rem 0.667rem 0.6rem 0.667rem;
      align-items: center;
      .thumbnail_129 {
        width: 0.32rem;
        height: 0.32rem;
      }
      .text-group_2 {
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.454rem;
        margin-left: 0.134rem;
      }
    }
  }
  .section_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    width: 9.147rem;
    align-self: center;
    padding: 0.427rem 0.427rem 0.427rem 0.427rem;
    margin-top: 0.427rem;
    .text_6 {
      overflow-wrap: break-word;
      color: rgba(51, 51, 51, 1);
      font-size: 0.48rem;
      font-weight: bold;
      text-align: left;
      white-space: nowrap;
      line-height: 0.667rem;
      margin-right: 6.4rem;
    }
    .paragraph_1 {
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      white-space: nowrap;
      line-height: 0.534rem;
      margin: 0.214rem 0.614rem 0 0;
    }
    .text_53 {
      width: 8.294rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.427rem;
    }
    .text_54 {
      width: 8.294rem;
      height: 1.067rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.427rem;
    }
    .text_55 {
      width: 8.294rem;
      height: 1.067rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.427rem;
    }
    .text_56 {
      width: 8.294rem;
      height: 1.6rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.427rem;
    }
    .box_6 {
      position: absolute;
      left: 0.294rem;
      top: 0.427rem;
      width: 0.614rem;
      height: 0.614rem;
      background: url(../../../assets/ceping113/box_6_15.png)
        100% no-repeat;
      background-size: 100% 100%;
    }
  }
  .section_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    width: 9.147rem;
    align-self: center;
    margin-top: 0.427rem;
    padding: 0.427rem 0.427rem 0.427rem 0.427rem;
    .section_19 {
      width: 4.08rem;
      align-self: center;
      .thumbnail_9 {
        width: 0.267rem;
        height: 0.24rem;
        margin: 0.24rem 0 0.267rem 0;
      }
      .image-text_165 {
        width: 3.627rem;
        .text-group_3 {
          overflow-wrap: break-word;
          color: rgba(6, 16, 41, 1);
          font-size: 0.533rem;
          font-weight: bolder;
          text-align: left;
          white-space: nowrap;
          line-height: 0.747rem;
        }
        .thumbnail_10 {
          width: 0.267rem;
          height: 0.24rem;
          margin: 0.24rem 0 0.267rem 0;
        }
      }
    }
    .text_7 {
      overflow-wrap: break-word;
      color: rgba(51, 51, 51, 1);
      font-size: 0.373rem;
      font-weight: bold;
      text-align: left;
      white-space: nowrap;
      line-height: 0.534rem;
      margin: 0.48rem 0.027rem 0 0.027rem;
    }
    .section_20 {
      width: 7.76rem;
      align-self: center;
      margin-top: 0.507rem;
      .paragraph_2 {
        width: 1.92rem;
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.293rem;
        font-weight: bold;
        text-align: left;
        line-height: 0.507rem;
        margin-top: 0.347rem;
      }
      .group_69 {
        margin-bottom: 0.16rem;
        .text-wrapper_61 {
          background-size: 0.774rem 0.534rem;
          margin: 0 1.387rem 0 3.547rem;
          padding: 0.027rem 0.214rem 0.134rem 0.214rem;
          .text_107 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.24rem;
            font-weight: bold;
            text-align: right;
            white-space: nowrap;
            line-height: 0.347rem;
          }
        }
        .image_2 {
          width: 5.68rem;
          height: 0.107rem;
          margin-top: 0.08rem;
        }
        .text-wrapper_62 {
          background-size: 0.8rem 0.534rem;
          margin: 0.32rem 1.654rem 0 3.28rem;
          padding: 0.027rem 0.214rem 0.134rem 0.214rem;
          .text_108 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.24rem;
            font-weight: bold;
            text-align: right;
            white-space: nowrap;
            line-height: 0.347rem;
          }
        }
        .image_3 {
          width: 5.68rem;
          height: 0.107rem;
          margin-top: 0.134rem;
        }
        .text-wrapper_63 {
          background-size: 0.774rem 0.534rem;
          margin: 0.32rem 1.814rem 0 3.12rem;
          padding: 0.027rem 0.214rem 0.134rem 0.214rem;
          .text_109 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.24rem;
            font-weight: bold;
            text-align: right;
            white-space: nowrap;
            line-height: 0.347rem;
          }
        }
        .image_4 {
          width: 5.68rem;
          height: 0.107rem;
          margin-top: 0.107rem;
        }
        .text-wrapper_64 {
          background-size: 0.774rem 0.534rem;
          margin: 0.32rem 1.974rem 0 2.96rem;
          padding: 0.027rem 0.214rem 0.134rem 0.214rem;
          .text_110 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.24rem;
            font-weight: bold;
            text-align: right;
            white-space: nowrap;
            line-height: 0.347rem;
          }
        }
        .image_5 {
          width: 5.68rem;
          height: 0.107rem;
          margin-top: 0.134rem;
        }
        .text-wrapper_65 {
          background-size: 0.774rem 0.534rem;
          margin: 0.32rem 2.16rem 0 2.774rem;
          padding: 0.027rem 0.214rem 0.134rem 0.214rem;
          .text_111 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.24rem;
            font-weight: bold;
            text-align: right;
            white-space: nowrap;
            line-height: 0.347rem;
          }
        }
        .image_6 {
          width: 5.68rem;
          height: 0.107rem;
          margin-top: 0.107rem;
        }
        .text-wrapper_66 {
          background-size: 0.774rem 0.534rem;
          margin: 0.32rem 2.267rem 0 2.667rem;
          padding: 0.027rem 0.214rem 0.134rem 0.214rem;
          .text_112 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.24rem;
            font-weight: bold;
            text-align: right;
            white-space: nowrap;
            line-height: 0.347rem;
          }
        }
        .image_7 {
          width: 5.68rem;
          height: 0.107rem;
          margin-top: 0.134rem;
        }
        .text-wrapper_67 {
          background-size: 0.774rem 0.534rem;
          margin: 0.32rem 2.694rem 0 2.24rem;
          padding: 0.027rem 0.214rem 0.134rem 0.214rem;
          .text_113 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.24rem;
            font-weight: bold;
            text-align: right;
            white-space: nowrap;
            line-height: 0.347rem;
          }
        }
        .image_8 {
          width: 5.68rem;
          height: 0.107rem;
          margin-top: 0.107rem;
        }
        .text-wrapper_68 {
          background-size: 0.8rem 0.534rem;
          margin: 0.32rem 2.907rem 0 2.027rem;
          padding: 0.027rem 0.214rem 0.134rem 0.214rem;
          .text_114 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.24rem;
            font-weight: bold;
            text-align: right;
            white-space: nowrap;
            line-height: 0.347rem;
          }
        }
        .image_9 {
          width: 5.68rem;
          height: 0.107rem;
          margin-top: 0.134rem;
        }
      }
    }
    .box_10 {
      position: relative;
      margin-top: 0.454rem;
      padding: 0.427rem 0.427rem 0.427rem 0.427rem;
      border-radius: 0.43rem;
      background: linear-gradient(180deg, #F4FFF2 0%, #FFFFFF 10%);

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 0.43rem;
        padding: 1px;
        background: linear-gradient(180deg, rgba(220, 255, 220, 1), rgba(240, 243, 255, 1));
        -webkit-mask: 
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask-composite: exclude;
      }

      .text_16 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.426rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.587rem;
        margin-right: 3.654rem;
      }
      .group_70 {
        width: 2.08rem;
        margin: 0.427rem 5.36rem 0 0;
        .thumbnail_130 {
          width: 0.374rem;
          height: 0.347rem;
          margin: 0.107rem 0 0.107rem 0;
        }
        .text_17 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.373rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
          line-height: 0.56rem;
        }
      }
      .text_18 {
        width: 7.44rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
        margin-top: 0.107rem;
      }
      .group_71 {
        width: 2.08rem;
        margin: 0.64rem 5.36rem 0 0;
        .thumbnail_131 {
          width: 0.374rem;
          height: 0.294rem;
          margin: 0.16rem 0 0.107rem 0;
        }
        .text_19 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.373rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
          line-height: 0.56rem;
        }
      }
      .text_20 {
        width: 7.44rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
        margin-top: 0.107rem;
      }
      .group_72 {
        width: 2.8rem;
        margin: 0.64rem 4.64rem 0 0;
        .thumbnail_132 {
          width: 0.374rem;
          height: 0.32rem;
          margin: 0.134rem 0 0.107rem 0;
        }
        .text_21 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.373rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
          line-height: 0.56rem;
        }
      }
      .text_22 {
        width: 7.44rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
        margin-top: 0.107rem;
      }
      .group_73 {
        width: 2.054rem;
        margin: 0.64rem 5.36rem 0 0.027rem;
        .thumbnail_133 {
          width: 0.32rem;
          height: 0.32rem;
          margin: 0.134rem 0 0.107rem 0;
        }
        .text_23 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.373rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
          line-height: 0.56rem;
        }
      }
      .text_24 {
        width: 7.44rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
        margin-top: 0.107rem;
      }
      .group_74 {
        width: 2.934rem;
        margin: 0.64rem 4.48rem 0 0.027rem;
        .thumbnail_134 {
          width: 0.32rem;
          height: 0.32rem;
          margin: 0.134rem 0 0.107rem 0;
        }
        .text_25 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.373rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
          line-height: 0.56rem;
        }
      }
      .text_26 {
        width: 7.44rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
        margin-top: 0.107rem;
      }
      .group_75 {
        width: 2.054rem;
        margin: 0.64rem 5.36rem 0 0.027rem;
        .thumbnail_135 {
          width: 0.32rem;
          height: 0.32rem;
          margin: 0.134rem 0 0.107rem 0;
        }
        .text_27 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.373rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
          line-height: 0.56rem;
        }
      }
      .text_28 {
        width: 7.44rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
        margin-top: 0.107rem;
      }
      .group_76 {
        width: 2.8rem;
        margin: 0.64rem 5.36rem 0 0.027rem;
        .thumbnail_136 {
          width: 0.32rem;
          height: 0.374rem;
          margin: 0.107rem 0 0.08rem 0;
        }
        .text_29 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.373rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
          line-height: 0.56rem;
        }
      }
      .text_30 {
        width: 7.44rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
        margin-top: 0.107rem;
      }
      .group_77 {
        width: 2.08rem;
        margin: 0.64rem 5.36rem 0 0;
        .thumbnail_137 {
          width: 0.374rem;
          height: 0.32rem;
          margin: 0.134rem 0 0.107rem 0;
        }
        .text_31 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.373rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
          line-height: 0.56rem;
        }
      }
      .text_32 {
        width: 7.44rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
        margin: 0.107rem 0.08rem 0 0;
      }
    }
  }
  .section_4 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    width: 9.147rem;
    align-self: center;
    margin-top: 0.427rem;
    padding: 0.427rem 0.427rem 0.427rem 0.427rem;
    .group_78 {
      width: 5.04rem;
      align-self: center;
      .thumbnail_19 {
        width: 0.267rem;
        height: 0.24rem;
        margin: 0.24rem 0 0.267rem 0;
      }
      .image-text_166 {
        width: 4.587rem;
        .text-group_4 {
          overflow-wrap: break-word;
          color: rgba(6, 16, 41, 1);
          font-size: 0.533rem;
          font-weight: bolder;
          text-align: left;
          white-space: nowrap;
          line-height: 0.747rem;
        }
        .thumbnail_20 {
          width: 0.267rem;
          height: 0.24rem;
          margin: 0.24rem 0 0.267rem 0;
        }
      }
    }
    .group_12 {
      position: relative;
      margin-top: 0.827rem;
      padding: 0.8rem 0.427rem 0.427rem 0.427rem;
      border-radius: 0.43rem;
      background: linear-gradient(180deg, #F4FFF2 0%, #FFFFFF 10%);
      gap: 0.427rem;

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 0.43rem;
        padding: 1px;
        background: linear-gradient(180deg, rgba(220, 255, 220, 1), rgba(240, 243, 255, 1));
        -webkit-mask: 
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask-composite: exclude;
      }

      .image-text_167 {
        width: 4.64rem;
        margin-right: 2.8rem;
        .thumbnail_21 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.08rem 0 0.134rem 0;
        }
        .text-group_5 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          white-space: nowrap;
          line-height: 0.427rem;
        }
      }
      .image-text_168 {
        width: 4rem;
        margin: 0.427rem 3.44rem 0 0;
        .thumbnail_22 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.107rem 0;
        }
        .text-group_6 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          white-space: nowrap;
          line-height: 0.427rem;
        }
      }
      .image-text_169 {
        width: 3.654rem;
        margin: 0.427rem 3.787rem 0 0;
        .thumbnail_23 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.107rem 0;
        }
        .text-group_7 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          white-space: nowrap;
          line-height: 0.427rem;
        }
      }
      .image-text_170 {
        width: 7.44rem;
        margin-top: 0.427rem;
        .thumbnail_24 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 1.44rem 0 0.16rem 0;
        }
        .text-group_63 {
          .text_33 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
          }
          .text_34 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
            line-height: 0.534rem;
            margin: 0.427rem 2rem 0 0;
          }
        }
      }
      .image-text_171 {
        width: 7.014rem;
        margin: 0.427rem 0.427rem 0 0;
        .thumbnail_25 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.16rem 0 0.16rem 0;
        }
        .text-group_9 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          white-space: nowrap;
          line-height: 0.534rem;
        }
      }
      .image-text_172 {
        width: 7.44rem;
        margin-top: 0.427rem;
        .thumbnail_26 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 1.387rem 0 0.534rem 0;
        }
        .text-group_64 {
          .text_35 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
          }
          .text_36 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
            margin-top: 0.427rem;
          }
        }
      }
      .image-text_173 {
        position: absolute;
        left: 0.427rem;
        top: 3.36rem;
        width: 7.44rem;
        height: 1.814rem;
        .thumbnail_27 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 1.494rem 0;
        }
        .text-group_65 {
          .text_33 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
          }
          .text_34 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
            line-height: 0.534rem;
            margin: 0.427rem 2rem 0 0;
          }
        }
      }
      .image-text_174 {
        position: absolute;
        left: 0.427rem;
        top: 6.56rem;
        width: 7.44rem;
        height: 2.134rem;
        .thumbnail_28 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 1.814rem 0;
        }
        .text-group_66 {
          .text_35 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
          }
          .text_36 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
            margin-top: 0.427rem;
          }
        }
      }
    }
    .group_13 {
      position: relative;
      margin-top: 0.854rem;
      padding: 0.8rem 0.32rem 0.427rem 0.32rem;
      border-radius: 0.43rem;
      background: linear-gradient(180deg, #F4FFF2 0%, #FFFFFF 10%);
      gap: 0.427rem;

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 0.43rem;
        padding: 1px;
        background: linear-gradient(180deg, rgba(220, 255, 220, 1), rgba(240, 243, 255, 1));
        -webkit-mask: 
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask-composite: exclude;
      }

      .group_14 {
        background-color: rgba(25, 201, 75, 0.1);
        border-radius: 0.2rem;
        position: relative;
        padding: 0.214rem 0.32rem 0.214rem 0.32rem;
        .text_37 {
          width: 7.014rem;
          text-indent: 1.5em;
          overflow-wrap: break-word;
          color: rgba(6, 16, 41, 0.7);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          line-height: 0.534rem;
        }
        .thumbnail_29 {
          position: absolute;
          left: 0.32rem;
          top: 0.32rem;
          width: 0.32rem;
          height: 0.32rem;
        }
      }
      .image-text_175 {
        width: 7.44rem;
        align-self: center;
        margin-top: 0.694rem;
        .thumbnail_30 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.08rem 0 0.56rem 0;
        }
        .text-group_13 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          line-height: 0.427rem;
        }
      }
      .image-text_176 {
        width: 7.44rem;
        align-self: center;
        margin-top: 0.427rem;
        .thumbnail_31 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.534rem 0;
        }
        .text-group_14 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          line-height: 0.427rem;
        }
      }
      .image-text_177 {
        width: 7.44rem;
        align-self: center;
        margin-top: 0.427rem;
        .thumbnail_32 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.534rem 0;
        }
        .text-group_15 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          line-height: 0.427rem;
        }
      }
      .image-text_178 {
        width: 7.44rem;
        align-self: center;
        margin-top: 0.427rem;
        .thumbnail_33 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.534rem 0;
        }
        .text-group_16 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          line-height: 0.427rem;
        }
      }
    }
    .text-wrapper_10 {
      background-color: rgba(25, 201, 75, 1);
      height: 1.44rem;
      width: 3.867rem;
      position: absolute;
      left: 0.427rem;
      top: 1.6rem;
      padding: 0.134rem 0.48rem 0.774rem 0.427rem;
      .text_38 {
        overflow-wrap: break-word;
        color: rgba(254, 254, 251, 1);
        font-size: 0.373rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.534rem;
      }
    }
    .text-wrapper_11 {
      background-color: rgba(25, 201, 75, 1);
      height: 1.44rem;
      width: 4.187rem;
      position: absolute;
      left: 0.427rem;
      top: 11.547rem;
      padding: 0.134rem 0.454rem 0.774rem 0.427rem;
      .text_39 {
        overflow-wrap: break-word;
        color: rgba(254, 254, 251, 1);
        font-size: 0.373rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.534rem;
      }
    }
  }
  .section_5 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    width: 9.147rem;
    align-self: center;
    margin-top: 0.427rem;
    padding: 0.427rem 0.427rem 0.427rem 0.427rem;
    .group_79 {
      width: 4.587rem;
      align-self: center;
      .thumbnail_34 {
        width: 0.267rem;
        height: 0.24rem;
        margin: 0.24rem 0 0.267rem 0;
      }
      .text_40 {
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 1);
        font-size: 0.533rem;
        font-weight: bolder;
        text-align: left;
        white-space: nowrap;
        line-height: 0.747rem;
      }
      .thumbnail_35 {
        width: 0.267rem;
        height: 0.24rem;
        margin: 0.24rem 0 0.267rem 0;
      }
    }
    .text_41 {
      width: 8.294rem;
      height: 1.067rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.214rem;
    }
    .box_12 {
      position: relative;
      margin-top: 0.827rem;
      padding: 0.8rem 0.427rem 0.427rem 0.427rem;
      border-radius: 0.43rem;
      background: linear-gradient(180deg, #F4FFF2 0%, #FFFFFF 10%);
      gap: 0.427rem;

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 0.43rem;
        padding: 1px;
        background: linear-gradient(180deg, rgba(220, 255, 220, 1), rgba(240, 243, 255, 1));
        -webkit-mask: 
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask-composite: exclude;
      }

      .image-text_179 {
        width: 7.44rem;
        .thumbnail_36 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.08rem 0 0.56rem 0;
        }
        .text-group_17 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          line-height: 0.427rem;
        }
      }
      .image-text_180 {
        width: 7.44rem;
        margin-top: 0.427rem;
        .thumbnail_37 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.534rem 0;
        }
        .text-group_18 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          line-height: 0.427rem;
        }
      }
      .image-text_181 {
        width: 7.44rem;
        margin-top: 0.427rem;
        .thumbnail_38 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.534rem 0;
        }
        .text-group_19 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          line-height: 0.427rem;
        }
      }
      .image-text_182 {
        width: 7.44rem;
        margin-top: 0.427rem;
        .thumbnail_39 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.534rem 0;
        }
        .text-group_20 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          line-height: 0.427rem;
        }
      }
      .image-text_183 {
        width: 7.334rem;
        margin: 0.427rem 0.107rem 0 0;
        .thumbnail_40 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.16rem 0 0.16rem 0;
        }
        .text-group_21 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          white-space: nowrap;
          line-height: 0.534rem;
        }
      }
    }
    .box_13 {
      position: relative;
      margin-top: 0.854rem;
      padding: 0.8rem 0.32rem 0.427rem 0.32rem;border-radius: 0.43rem;
      background: linear-gradient(180deg, #F4FFF2 0%, #FFFFFF 10%);
      gap: 0.427rem;

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 0.43rem;
        padding: 1px;
        background: linear-gradient(180deg, rgba(220, 255, 220, 1), rgba(240, 243, 255, 1));
        -webkit-mask: 
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask-composite: exclude;
      }

      .image-text_184 {
        width: 7.44rem;
        align-self: center;
        .thumbnail_41 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 2.667rem 0 0.107rem 0;
        }
        .text-group_67 {
          .text_42 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
          }
          .text_43 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
            margin-top: 0.427rem;
          }
          .text_44 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
            line-height: 0.427rem;
            margin: 0.427rem 0.107rem 0 0;
          }
        }
      }
      .image-text_185 {
        width: 6.4rem;
        margin: 0.427rem 1.147rem 0 0.107rem;
        .thumbnail_42 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.107rem 0;
        }
        .text-group_23 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          white-space: nowrap;
          line-height: 0.427rem;
        }
      }
      .group_15 {
        background-color: rgba(25, 201, 75, 0.1);
        border-radius: 0.2rem;
        padding: 0.214rem 0.4rem 0.214rem 0.32rem;
        .image-text_186 {
          width: 6.934rem;
          align-items: center;
          .thumbnail_43 {
            width: 0.32rem;
            height: 0.32rem;
          }
          .text-group_24 {
            overflow-wrap: break-word;
            color: rgba(6, 16, 41, 0.7);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
          }
        }
      }
      .image-text_187 {
        position: absolute;
        left: 0.427rem;
        top: 0.8rem;
        width: 7.44rem;
        height: 2.987rem;
        .thumbnail_44 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.08rem 0 2.694rem 0;
        }
        .text-group_68 {
          .text_42 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
          }
          .text_43 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
            margin-top: 0.427rem;
          }
          .text_44 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
            line-height: 0.427rem;
            margin: 0.427rem 0.107rem 0 0;
          }
        }
      }
      .image-text_188 {
        position: absolute;
        left: 0.427rem;
        top: 0.8rem;
        width: 7.44rem;
        height: 2.987rem;
        .thumbnail_45 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 1.387rem 0 1.387rem 0;
        }
        .text-group_69 {
          .text_42 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
          }
          .text_43 {
            width: 7.04rem;
            height: 0.854rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            line-height: 0.427rem;
            margin-top: 0.427rem;
          }
          .text_44 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
            line-height: 0.427rem;
            margin: 0.427rem 0.107rem 0 0;
          }
        }
      }
    }
    .text-wrapper_12 {
      background-color: rgba(25, 201, 75, 1);
      height: 1.44rem;
      width: 4.587rem;
      position: absolute;
      left: 0.427rem;
      top: 2.88rem;
      padding: 0.134rem 0.48rem 0.774rem 0.427rem;
      .text_45 {
        overflow-wrap: break-word;
        color: rgba(254, 254, 251, 1);
        font-size: 0.373rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.534rem;
      }
    }
    .text-wrapper_13 {
      background-color: rgba(25, 201, 75, 1);
      height: 1.44rem;
      width: 4.587rem;
      position: absolute;
      left: 0.427rem;
      top: 10.587rem;
      padding: 0.134rem 0.48rem 0.774rem 0.427rem;
      .text_46 {
        overflow-wrap: break-word;
        color: rgba(254, 254, 251, 1);
        font-size: 0.373rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.534rem;
      }
    }
  }
  .section_6 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    width: 9.147rem;
    align-self: center;
    margin-top: 0.427rem;
    padding: 0.427rem 0.427rem 0.427rem 0.427rem;
    .group_80 {
      width: 1.974rem;
      align-self: center;
      .thumbnail_46 {
        width: 0.267rem;
        height: 0.24rem;
        margin: 0.24rem 0 0.267rem 0;
      }
      .image-text_189 {
        width: 1.52rem;
        .text-group_27 {
          overflow-wrap: break-word;
          color: rgba(6, 16, 41, 0.7);
          font-size: 0.533rem;
          font-weight: bolder;
          text-align: left;
          white-space: nowrap;
          line-height: 0.747rem;
        }
        .thumbnail_47 {
          width: 0.267rem;
          height: 0.24rem;
          margin: 0.24rem 0 0.267rem 0;
        }
      }
    }
    .text_47 {
      width: 8.294rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.427rem;
    }
  }
  .text_48 {
    overflow-wrap: break-word;
    color: rgba(6, 16, 41, 0.7);
    font-size: 0.266rem;
    font-weight: normal;
    text-align: justify;
    line-height: 0.534rem;
    margin: 0.427rem 0.88rem 0 0.854rem;
  }

  .group_18 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    width: 9.147rem;
    padding: 0.427rem 0.427rem 0.427rem 0.294rem;
    align-self: center;
    .box_42 {
      margin-right: 6.4rem;
      .box_15 {
        width: 0.614rem;
        height: 0.614rem;
        background: url(../../../assets/ceping113/box_6_15.png)
          100% no-repeat;
        background-size: 100% 100%;
        margin-bottom: 0.054rem;
      }
      .text_49 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.48rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.667rem;
        margin-left: -0.48rem;
      }
    }
    .text_50 {
      width: 8.294rem;
      height: 2.667rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin: 0.214rem 0 0 0.134rem;
    }
  }
}
</style>